import { useEffect, useState } from "react";
import { cn } from "#scripts/lib/utils.ts";

export interface ConsoleLine {
  id: string;
  message: string;
  timestamp: Date;
}

interface MockConsoleProps {
  lines: ConsoleLine[];
  maxLines?: number;
}

export function MockConsole({ lines, maxLines = 10 }: MockConsoleProps) {
  const displayLines = lines.slice(-maxLines);

  return (
    <div data-loc="phosphor-blog/scripts/components/demo/mock-console.tsx:19:10" data-name="div" className="bg-black border border-border rounded-md p-3 font-mono text-xs text-text-secondary overflow-hidden">
      <div data-loc="phosphor-blog/scripts/components/demo/mock-console.tsx:20:12" data-name="div" className="flex items-center gap-2 mb-2 pb-2 border-b border-border">
        <div data-loc="phosphor-blog/scripts/components/demo/mock-console.tsx:21:14" data-name="div" className="flex gap-1.5">
          <div data-loc="phosphor-blog/scripts/components/demo/mock-console.tsx:22:16" data-name="div" className="w-3 h-3 rounded-full bg-red-500" />
          <div data-loc="phosphor-blog/scripts/components/demo/mock-console.tsx:23:16" data-name="div" className="w-3 h-3 rounded-full bg-yellow-500" />
          <div data-loc="phosphor-blog/scripts/components/demo/mock-console.tsx:24:16" data-name="div" className="w-3 h-3 rounded-full bg-green-500" />
        </div>
        <span data-loc="phosphor-blog/scripts/components/demo/mock-console.tsx:26:15" data-name="span" className="text-text-tertiary">Console</span>
      </div>
      <div data-loc="phosphor-blog/scripts/components/demo/mock-console.tsx:28:12" data-name="div" className="space-y-1 min-h-[120px]">
        {displayLines.length === 0 && <div data-loc="phosphor-blog/scripts/components/demo/mock-console.tsx:29:44" data-name="div" className="text-text-tertiary italic">Waiting for interaction...</div>}
        {displayLines.map((line) => (
          <ConsoleLineComponent key={line.id} line={line} />
        ))}
      </div>
    </div>
  );
}

function ConsoleLineComponent({ line }: { line: ConsoleLine }) {
  const [isNew, setIsNew] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setIsNew(false), 300);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div data-loc="phosphor-blog/scripts/components/demo/mock-console.tsx:47:10" data-name="div" className={cn("flex items-start gap-2 transition-all duration-300", isNew && "text-accent animate-pulse")}>
      <span data-loc="phosphor-blog/scripts/components/demo/mock-console.tsx:48:13" data-name="span" className="text-accent-muted">↗</span>
      <span>{line.message}</span>
    </div>
  );
}
